import React from 'react'
import { Link } from 'react-router-dom'
import './SubMenuComponent.css'
export default function SubMenuComponent({ subMenus, index, selectedMenuIndex }) {
    return (
        <div className={`navbar-submenu ${selectedMenuIndex === index ? 'active' : ''}`}>
            <ul className='navbar-submenu-ul'>
                {
                    subMenus?.map((subMenu,index) => (
                        subMenu.courses.length != 0 ||  subMenu.products.length != 0 ? (
                        <li className='submenu-list' key={index}>
                            <div className='submenu-list-title'>
                                <h3>{subMenu.title}</h3>
                            </div>
                            <div>
                            <ul>
                                {
                                    subMenu.courses.map((courseData,indexx) => (
                                        <li key={indexx}>
                                            <Link to={`/course/${courseData.title}`}>
                                                {courseData.title}
                                            </Link>
                                        </li>
                                    ))
                                }
                                  {
                                    subMenu.products.map((courseData) => (
                                        <li key={courseData.id}>
                                            <Link to={`/product/${courseData.title}`}>
                                                {courseData.title}
                                            </Link>
                                        </li>
                                    ))
                                }
                            </ul>
                            </div>
                        </li>) : (null)

                    ))
                }
            </ul>
        </div>
    )
}
